module.exports = "<div gw-loader=\"accountDetailsPromise\">\n    <div gw-claim-summary\n         account=\"accountInfo\">\n    </div>\n</div>"